<template>
    <div class="field">
        <label :class="isFieldRequired ? 'req' : ''">{{ label }}</label>
        <div class="autocomplete autoComplete_wrapper">
            <div class="input_wrapper">
                <input :disabled="isDataUpdating || isDisabled" :aria-invalid="modelValue?.length === 0"
                       :value="modelValue"
                       type="text"
                       :class="isFieldHasError ? 'has_errors':''"
                       @input="onChange"
                       @keydown.down="onArrowDown"
                       @keydown.up="onArrowUp"
                       @keydown.enter.prevent="onEnter"
                       style="background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%; cursor: auto;">
                <span v-if="isCountryFilled && !isDisabled" @click="clearCountry" class="clearIcon clearIcon3"><i
                        class="fas fa-times"></i></span>
            </div>

            <ul
                    v-show="isOpen"
                    class="autocomplete-results"
            >
                <li
                        v-if="isLoading"
                        class="loading"
                >
                    Загрузка...
                </li>
                <template v-else>
                    <template v-if="results.length > 0">
                        <li
                                v-for="(result, i) in results"
                                @click="setResult(result)"
                                :key="i"
                                class="autocomplete-result"
                                :class="{ 'is-active': i === arrowCounter }"
                        >
                            {{ result['ru_name'] }}
                        </li>
                    </template>
                    <template v-else>
                        <li>Ничего не найдено</li>
                    </template>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
module.exports = {
  name: 'SearchAutocomplete',
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    label: {},
    objectKey: {},
    index: {
      type: Number,
      required: false,
      default: 0
    },
    isAsync: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDataUpdating: {},
    isSubmitted: {},
    modelValue: {},
    isDisabled: {}
  },
  data() {
    return {
      search: this.modelValue,
      results: [],
      isOpen: false,
      isFormSubmittedVal: this.isFormSubmitted,
      arrowCounter: -1,
      isLoading: false
    };
  },
  inject: ['$validator'],
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  computed: {
    isFieldHasError() {
      return !!(this.isFieldRequired && this.isSubmitted && (this.modelValue === undefined || this.modelValue.length === 0));
    },
    isCountryFilled() {
      return this.$parent.country?.length > 0;
      //return this.parentObj !== undefined ? this.$parent.project[this.parentObj][this.objectKey]  : this.$parent.project[this.objectKey];
    },
    isFieldRequired() {
      return this.$parent.isFieldRequired(this.objectKey)
    },
  },
  methods: {
    filterResults() {
      this.results = this.items.filter(item => item['ru_name'].toLowerCase().indexOf(this.modelValue?.toLowerCase()) > -1);
    },
    setResult(result) {
      this.$emit('update:modelValue', result['ru_name'])

      this.$emit('onSetResult', result['ru_name'])
      //this.search = result['ru_name'];
      this.setParentResult();
      this.isOpen = false;
    },
    onChange($event) {
      this.$emit('update:modelValue', $event.target.value)
      this.filterResults();
      this.isOpen = true;
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.arrowCounter = -1;
        this.isOpen = false;
      }
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      this.$emit('update:modelValue', this.results[this.arrowCounter]['ru_name'])
      //this.search = this.results[this.arrowCounter]['ru_name'];
      this.setParentResult();
      this.arrowCounter = -1;
      this.isOpen = false;
    },
    setParentResult() {
      //this.$parent.country = this.search;
      this.$parent.loadCities();
      this.$parent.loadRegions();
      this.$parent.saveData();
    },
    setDefaultValue(country) {
      this.search = country;
    },

    clearCountry() {
      //this.$emit('update:modelValue', "")
      this.$emit('onClearResult')
      //this.$parent.saveData();
    }
  }
}
</script>
<style scoped>
.autocomplete {
    position: relative;
}

.autocomplete .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 150px;
    min-height: 1em;
    overflow: auto;
}

.autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
    background-color: #4AAE9B;
    color: white;
}

.input_wrapper {
    position: relative;
}

.field input[type="text"] {
    padding-left: 20px;
}

.clearIcon {
    position: absolute;
    left: 6px;
    top: 15px;
    cursor: pointer;
    font-size: 15px;
}

.clearIcon i {
    font-size: 15px;
}
</style>